import moment from 'moment';

export const getElapsedHours = (start, end) => {
    if (!start || !end) {
        return null;
    }

    const startMoment = fromUtcToLocalMoment(start);
    const endMoment = fromUtcToLocalMoment(end);

    return moment(endMoment).diff(startMoment) / (1000 * 60 * 60);
};

// https://stackoverflow.com/a/57567327
/**
 * @param {date|moment} start The start date
 * @param {date|moment} end The end date
 * @param {string} type The range type. eg: 'days', 'hours' etc
 */
export const getRange = (startDate, endDate, type) => {
    let fromDate = moment(startDate);
    let toDate = moment(endDate);
    let diff = toDate.diff(fromDate, type);
    let range = [];
    for (let i = 0; i <= diff; i++) {
        range.push(moment(startDate).add(i, type));
    }
    return range;
};

/**
 * If you know that the _string_ date you're working with is UTC, this will coax
 * out a UTC->local moment object to work with.
 * @param {*} date
 * @returns
 */
export const fromUtcToLocalMoment = (date) => {
    if (date && date instanceof Date) {
        return moment(date);
    }

    if (!date || !date.endsWith) {
        return date;
    }

    return date.endsWith('Z')
        ? moment(date).local()
        : moment(`${date}Z`).local();
};
